import { Grid2 } from "@mui/material";
import useUIBp from "../../../../../Hooks/useUIBoilerplate";
import { UIactions } from "../../../../../store/slices/UI";
import Button from "../../../../UI/GeneralPurpose/Button";
import { defaultFilter, defaultPagination } from "../../../../UI/GeneralPurpose/genericIDs";
import { ContainsId } from "./Fields/Contains";
import { DateFromId } from "./Fields/DateFrom";
import { DateUntilId } from "./Fields/DateUntil";
import { FromId } from "./Fields/From";
import { SubjectId } from "./Fields/Subject";
import { ToId } from "./Fields/To";

const UITextClose = {
  "es-CL": { label: "Cerrar" },
  "en-US": { label: "Close" },
};

const UITextClear = {
  "es-CL": { label: "Eliminar Filtro" },
  "en-US": { label: "Clear Filter" },
};

const UITextFilter = {
  "es-CL": { label: "Aplicar Filtro" },
  "en-US": { label: "Apply Filter" },
};

const Actions = ({onClose:handleClose}) => {
    const {dispatch, UI} = useUIBp();

    const handleClear = () => {
        dispatch(UIactions.clear(FromId));
        dispatch(UIactions.clear(ToId));
        dispatch(UIactions.clear(SubjectId));
        dispatch(UIactions.clear(ContainsId));
        dispatch(UIactions.clear(DateFromId));
        dispatch(UIactions.clear(DateUntilId));
        dispatch(UIactions.clear(defaultFilter));
        handleClose();
    }

    const handleApplyFilter = () => {
        let filterArray = [];

        if (UI[FromId]) {
            filterArray.push(`from:(${UI[FromId].value})`);
        }
        if (UI[ToId]) {
            filterArray.push(`to:(${UI[ToId].value})`);
        }
        if (UI[SubjectId]) {
            filterArray.push(`subject:(${UI[SubjectId].value})`);
        }
        if (UI[DateFromId] && UI[DateFromId].value !== null) {
            filterArray.push(`startDate:${UI[DateFromId].value.format("DD-MM-YYYY")}`);
        }
        if (UI[DateUntilId] && UI[DateUntilId].value !== null) {
            filterArray.push(`endDate:${UI[DateUntilId].value.format("DD-MM-YYYY")}`);
        }
        if (UI[ContainsId]) {
            filterArray.push(`${UI[ContainsId].value}`);
        }
        const filterString = filterArray.join(" ");

        dispatch(UIactions.setValue({id: defaultFilter,value:filterString}));
        dispatch(UIactions.clear(defaultPagination))
        handleClose();
    }


  return (
    <Grid2 container {...{ size: 12, justifyContent: "end", columnGap: 2 }}>
      <Button
        {...{
          id: "close",
          UIText: UITextClose,
          variant: "outlined",
          onClick: () => {
            handleClose();
          },
        }}
      />
      <Button
        {...{
          id: "close",
          UIText: UITextClear,
          variant: "outlined",
          onClick: handleClear,
        }}
      />
      <Button
        {...{
          id: "close",
          UIText: UITextFilter,
          onClick: handleApplyFilter,
        }}
      />
    </Grid2>
  );
};

export default Actions;
